import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {PlaceholderWrapperComponent} from "../../../../core/components/placeholder/placeholder-wrapper";
import {DeviceViewModel} from "../../../../core/models/device.view-model";
import {PreviousMeetingsWidgetPlaceholderCompetitor} from "./previous-meetings-widget.placeholder-competitor";
import {PreviousMeetingsWidgetPlaceholderStatistic} from "./previous-meetings-widget.placeholder-statistic";

export class PreviousMeetingsWidgetHeaderPlaceholderProps extends BaseProps {
  device: DeviceViewModel;
}

export const PreviousMeetingsWidgetHeaderPlaceholder = (props: PreviousMeetingsWidgetHeaderPlaceholderProps) => {
  return (
    <PlaceholderWrapperComponent className={'previous-meetings-widget-placeholder-header-container'}>
      <div className={'previous-meetings-widget-placeholder-header-content'}>
        <div className={'previous-meetings-widget-placeholder-header-title-container'}>
          {!props.device.isSmallView && <div className={'previous-meetings-widget-placeholder-header-title'}/>}
        </div>
        <div className={'previous-meetings-widget-placeholder-header-content-container'}>
          <PreviousMeetingsWidgetPlaceholderCompetitor/>
          <div className={'previous-meetings-widget-placeholder-header-statistics'}>
            <PreviousMeetingsWidgetPlaceholderStatistic/>
            <div className={'previous-meetings-widget-placeholder-header-divider'}/>
            <PreviousMeetingsWidgetPlaceholderStatistic/>
            <div className={'previous-meetings-widget-placeholder-header-divider'}/>
            <PreviousMeetingsWidgetPlaceholderStatistic/>
          </div>
          <PreviousMeetingsWidgetPlaceholderCompetitor/>
        </div>
      </div>
    </PlaceholderWrapperComponent>
  )
}
